"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePageSize = void 0;
const react_redux_1 = require("react-redux");
const store_1 = require("../../../../store");
const usePageSize = () => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const pageSize = (0, store_1.usePageSize)();
    const onPageSizeChange = (newPageSize) => dispatch((0, store_1.enrichAISetPageSize)(newPageSize));
    return [
        pageSize,
        onPageSizeChange,
    ];
};
exports.usePageSize = usePageSize;
